import { createFileRoute } from '@tanstack/react-router';
import { NewMenuScreen } from '@/features/menus/NewMenuScreen';

export const Route = createFileRoute('/_app/menus/new')({
  component: NewMenuScreen,
});
